export default __webpack_public_path__ + "static/media/img_box.881d0fc3.png";